import { useState, useEffect } from 'react';
import { loadAsync } from 'expo-font';
import { logError } from '@/utils/logHandling';

import { Platform } from 'react-native';

const fonts = {
  ABeeZeeItalic:
    Platform.OS === 'web'
      ? { uri: '/fonts/ABeeZee/ABeeZee-Italic.ttf' }
      : require('../assets/fonts/ABeeZee/ABeeZee-Italic.ttf'),

  ABeeZeeRegular:
    Platform.OS === 'web'
      ? { uri: '/fonts/ABeeZee/ABeeZee-Regular.ttf' }
      : require('../assets/fonts/ABeeZee/ABeeZee-Regular.ttf'),

  Inter:
    Platform.OS === 'web'
      ? { uri: '/fonts/Inter/Inter_24pt-Regular.ttf' }
      : require('../assets/fonts/Inter/Inter_24pt-Regular.ttf'),
  InterSemiBold:
    Platform.OS === 'web'
      ? { uri: '/fonts/Inter/Inter_24pt-SemiBold.ttf' }
      : require('../assets/fonts/Inter/Inter_24pt-SemiBold.ttf'),
};

export const useFont = () => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    async function loadFonts() {
      try {
        await loadAsync(fonts);
        setFontsLoaded(true);
      } catch (error) {
        setFontsLoaded(false);
        logError('Error loading font', error);
      }
    }

    loadFonts();
  }, []);

  return fontsLoaded;
};
